import { IconButton, IconButtonProps, styled } from '@mui/material'

type HeaderIconButtonProps = IconButtonProps & {
  isMobile?: boolean
}

export const HeaderIconButton = styled(IconButton, {
  shouldForwardProp: (prop) => prop !== 'isMobile',
})<HeaderIconButtonProps>(({ theme, isMobile }) => ({
  width: '40px',
  height: '40px',
  background: isMobile ? theme.palette.primary.dark : 'transparent',
  border: `1px solid ${theme.palette.primary.light}`,
  color: theme.palette.background.default,
  '&:hover': {
    background: theme.palette.primary.light,
  },
}))
